// extracted by mini-css-extract-plugin
export default {"container":"Header_container__-t+Wv","title":"Header_title__I8atA"};